import React from "react";
import CptShimmerBlock from "../CptShimmerBlock";

const TimelineReportShimmer = () => (
  <div className="mpr-shimmer-wrap na-timeline-shimmer" aria-busy="true" aria-label="Loading timeline">
    <div className="nax-page-head mpr-shimmer-shell-row">
      <div className="nax-page-title-wrap">
        <CptShimmerBlock className="mpr-shimmer-icon-block nax-page-title-icon-shimmer" />
        <div className="chart-header-copy-modern">
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--title" />
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--subtitle" />
        </div>
      </div>
      <CptShimmerBlock className="mpr-shimmer-export mpr-shimmer-export--compact" />
    </div>

    <div className="nax-top-grid">
      <div className="nax-card nax-patient-card mpr-shimmer-shell-card">
        <CptShimmerBlock className="mpr-shimmer-avatar mpr-shimmer-avatar--lg" />
        <div className="nax-patient-copy">
          <div className="mpr-shimmer-patient-title-row">
            <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--title" />
            <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--badge" />
          </div>
          <div className="nax-patient-meta mpr-shimmer-meta-grid">
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className="mpr-shimmer-meta-item">
                <CptShimmerBlock className="mpr-shimmer-meta-icon" />
                <div className="mpr-shimmer-cell-lines">
                  <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
                  <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--md" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="nax-card nax-provider-card mpr-shimmer-shell-card">
        <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
        <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--md" />
        <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
        <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--md" />
      </div>
      <div className="nax-card nax-streak-grid mpr-shimmer-shell-card">
        {[1, 2].map((item) => (
          <div key={item} className="mpr-shimmer-streak-cell">
            <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
            <CptShimmerBlock className="mpr-shimmer-stat-value-line" />
            <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--subtitle" />
          </div>
        ))}
      </div>
    </div>

    <div className="nax-kpi-row">
      <div className="nax-card mpr-shimmer-shell-card mpr-shimmer-config-card">
        <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--title" />
        <div className="nax-config-grid">
          <div>
            <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
            <div className="mpr-shimmer-chip-row">
              {[1, 2, 3].map((chip) => (
                <CptShimmerBlock key={chip} className="mpr-shimmer-chip" />
              ))}
            </div>
          </div>
          <div>
            <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
            <div className="mpr-shimmer-chip-row">
              {[1, 2].map((chip) => (
                <CptShimmerBlock key={chip} className="mpr-shimmer-chip" />
              ))}
            </div>
          </div>
        </div>
      </div>
      {[1, 2, 3].map((item) => (
        <div key={item} className="nax-card nax-metric-card mpr-shimmer-shell-card mpr-shimmer-metric-card">
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
          <CptShimmerBlock className="mpr-shimmer-stat-value-line" />
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-divider" />
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--md" />
        </div>
      ))}
    </div>

    <div className="nax-card nax-timeline-section mpr-shimmer-shell-card">
      <div className="nax-timeline-head mpr-shimmer-header-row">
        <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--title" />
        <CptShimmerBlock className="mpr-shimmer-export mpr-shimmer-export--compact" />
      </div>
      <div className="mpr-shimmer-timeline-track">
        {Array.from({ length: 8 }).map((item) => (
          <div key={item} className="mpr-shimmer-timeline-month">
            <CptShimmerBlock className="mpr-shimmer-timeline-dot" />
            <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default TimelineReportShimmer;
